import React, { useEffect,useState } from 'react';
import { Box } from '@mui/system';
import Header from '../../../common/header/Header';
import Breadcrumb from '../../../common/header/Breadcrumb';
import BillingPlanLayout from './BillingPlanLayout';

const BillingPlan = () => {
    const [tabValue, setTabValue] = useState(0);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Box sx={{ flexGrow: 1 }} className="page-background">
            <Header />
            <Breadcrumb />
            <div className="inspection-details">
                <BillingPlanLayout tabValue={tabValue} setTabValue={setTabValue} />
            </div>
        </Box>
    );
};
export default BillingPlan;
